<div class="container-fluid">
	<h1 class="my-3 text-capitalize">Recibir Envío</h1>
	<div class="row align-items-start" *ngIf="shipping_info">
		<div class="col-12 col-lg-5">
			<h2>Datos del Envío</h2>
			<div class="card my-3 p-3">
				<form id="save-shipping" (submit)="save($event)" ngNativeValidate>
					<div class="row mx-0">
						<div class="col-6 px-1 py-2">
							<label class="">Número Económico ó Guia</label>
							<div>
								<b>{{shipping_info.shipping?.shipping_guide}}</b>
							</div>
						</div>
						<div class="col-6 px-1 py-2">
							<label class="">Condutor o Paquetería</label>
							<div>
								<b>{{shipping_info.shipping?.shipping_company}}</b>
							</div>
						</div>
						<div class="col-6 px-1 py-2" *ngIf="shipping_info.shipping.from_store_id">
							<label class="">Almacén Origen</label>
							<div>
								<b>{{store_dictionary[ shipping_info.shipping.from_store_id ]?.name }}</b>
							</div>
						</div>
						<div class="col-6 px-1 py-2" *ngIf="shipping_info.shipping.purchase_id">
							<label class="">Origen</label>
							<div>
								<a [routerLink]="['/purchase/edit', shipping_info.shipping.purchase_id]" *ngIf="rest.current_permission.add_purchases">Orden de compra #{{shipping_info.shipping.purchase_id}}</a>
								<b *ngIf="!rest.current_permission.add_purchases">Orden de compra #{{shipping_info.shipping.purchase_id}}</b>
							</div>
						</div>
						<div class="col-6 px-1 py-2">
							<label class="">Almacén Destino</label>
							<div>
								<b>{{store_dictionary[ shipping_info.shipping.to_store_id ]?.name }}</b>
							</div>
						</div>
						<div class="col-6 px-1 py-2">
							<label class="">Fecha de envío</label>
							<div>
								<b>{{ shipping_info.shipping?.date | shortDate: 'full'}}</b>
							</div>
						</div>
						<div class="col-6 px-1 py-2">
							<label class="">Recibido</label>
							<div>
								<b>{{ shipping_info.shipping.delivery_timestamp | shortDate: 'full'}}</b>
							</div>
						</div>
						<div class="col-12">
							<label class="">Nota</label>
							<div>
								<b>{{ shipping_info.shipping.note }}</b>
							</div>
						</div>
					</div>
				</form>
			</div>
			<ng-container *ngIf="shipping_info?.shipping.status != 'SENT'">
				<h2>Resumen</h2>
				<div class="card px-1 px-md-3 py-3 my-3">
					<div *ngIf="total_pallets" class="row">
						<div class="col-8">Total Tarimas</div>
						<div class="col-4 text-end">{{total_pallets}}</div>
					</div>
					<div class="row" *ngIf="total_individual_boxes">
						<div class="col-8">Total Cajas Sueltas</div>
						<div class="col-4 text-end">{{total_individual_boxes}}</div>
					</div>
					<div class="row" *ngIf="total_boxes">
						<div class="col-8">Total Cajas</div>
						<div class="col-4 text-end">{{total_boxes}}</div>
					</div>
					<div class="row" *ngIf="total_items && shipping_info.shipping.status != 'SENT'">
						<div class="col-8">Total Elementos</div>
						<div class="col-4 text-end">{{total_items}}</div>
					</div>
					<div class="row">
						<div class="col-8">Total Elementos Recibidos</div>
						<div class="col-4 text-end">{{total_received_items}}</div>
					</div>
				</div>
			</ng-container>
		</div>
		<div class="col-12 col-lg-7">
			<h2>Artículos</h2>
			<div class="card my-3 px-3 px-lg-3" *ngIf="shipping_info">
				<div class="row d-none d-md-flex fw-bold border-bottom py-3">
					<div [ngClass]="{'col-4': shipping_info.shipping.status == 'SENT', 'col-6': shipping_info.shipping.status != 'SENT'}">Artículos</div>
					<div class="col-2 text-end" *ngIf="shipping_info.shipping.status != 'SENT'">Enviados</div>
					<div class="col-2 text-end" [ngClass]="{'col-md-2':shipping_info.shipping.status !='SENT','col-md-3':shipping_info.shipping.status=='SENT'}">
						Recibido (funcional)
					</div>
					<div class="col-2 text-end" [ngClass]="{'col-md-2':shipping_info.shipping.status !='SENT','col-md-3':shipping_info.shipping.status=='SENT'}">
						Merma
					</div>
					<div class="col-2 text-center" *ngIf="shipping_info.shipping.status == 'SENT'">Almacén Destino</div>
				</div>
				<ng-container *ngFor="let sii of shipping_info.items;let i=index">
					<div *ngIf="sii.shipping_item.item_id" class="row border-bottom pb-2 mt-2 align-items-center" [ngClass]="{'text-danger':shipping_info.shipping.status != 'SENT' && sii.shipping_item.received_qty != sii.shipping_item.qty}">
						<div class="col-12 align-self-center fw-bold" [ngClass]="{'col-md-4': shipping_info.shipping.status == 'SENT', 'col-md-6': shipping_info.shipping.status != 'SENT'}">
							<b>{{ i+1 }} - </b>
							<img [src]="rest.getImagePath(sii.item?.image_id,sii?.category?.image_id)" style="max-height:30px;max-width:30px;margin-right:10px">
							<span *ngIf="rest.local_preferences.display_categories_on_items == 'YES'" class="text-secondary">{{sii?.category?.name}} - </span>
							<b>{{sii.item.name |titlecase }}</b>
							<span *ngIf="sii.shipping_item.serial_number">({{sii.shipping_item.serial_number |titlecase }})</span>
							<span *ngIf="rest.local_preferences.display_item_identifier == 'CODE' || rest.local_preferences.display_item_identifier == 'BOTH'">
								<a [routerLink]="['/list-item']" [queryParams]="{'csv.id':''+sii.item.id}" *ngIf="sii.item.code"> {{sii.item.code | uppercase }} </a>
							</span>
							<span *ngIf="(rest.local_preferences.display_item_identifier == 'TAGS' || rest.local_preferences.display_item_identifier == 'BOTH') && sii.item.json_tags?.length">
								<span *ngFor="let tag of sii.item.json_tags"> {{tag | uppercase}}</span>
							</span>
							<!-- Batch indicator -->
							<button type="button" *ngIf="hasBatches(sii)" class="btn btn-sm btn-link p-0 ms-2" (click)="toggleBatches(sii)" title="Ver lotes">
								<svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24"><path fill="currentColor" d="M5 21q-.825 0-1.413-.588T3 19V5q0-.825.588-1.413T5 3h14q.825 0 1.413.588T21 5v14q0 .825-.588 1.413T19 21H5Zm0-2h14V5H5v14Zm2-2h10v-2H7v2Zm0-4h10v-2H7v2Zm0-4h10V7H7v2Z"/></svg>
								<span class="badge bg-secondary">{{sii.shipping_item_batches.length}}</span>
							</button>
						</div>

						<div class="col-12 col-md-2 align-self-center text-end" *ngIf="shipping_info.shipping.status == 'DELIVERED'">
							<span class="d-md-none fw-bold">Enviado</span>
							{{sii.shipping_item.qty | number }}
						</div>

						<div class="col-12 text-end" [ngClass]="{'col-md-2':shipping_info.shipping.status !='SENT','col-md-3':shipping_info.shipping.status=='SENT'}">
							<label class="d-md-none fw-bold">Recibido (funcional)</label>
							<ng-container *ngIf="sii.shipping_item.serial_number">
								<div class="form-check form-switch" *ngIf="sii.shipping_item.serial_number">
									<label class="form-check-label">
										<input type="checkbox" *ngIf="shipping_info.shipping.status	!= 'DELIVERED'"  [name]="'shippint_item-b'+sii.shipping_item.id" (change)="onClickedCheckBox($event, sii.shipping_item)" class="form-check-input" value="1">
									</label>
								</div>
							</ng-container>
							<ng-container *ngIf="!sii.shipping_item.serial_number">
								<ng-container *ngIf="!hasBatches(sii)">
									<input *ngIf="shipping_info.shipping.status	!= 'DELIVERED'" type="number" [name]="'shippint_item'+sii.shipping_item.item_id" min="0" [(ngModel)]="sii.shipping_item.received_qty" (change)="calculateReceivedItems()" class="form-control text-end" required>
								</ng-container>
								<ng-container *ngIf="hasBatches(sii) && shipping_info.shipping.status != 'DELIVERED'">
									<span class="text-muted">(ver lotes)</span>
								</ng-container>
								<ng-container *ngIf="shipping_info.shipping.status	== 'DELIVERED'">
									{{sii.shipping_item.received_qty | number }}
								</ng-container>
							</ng-container>
						</div>

						<div class="col-12 text-end" [ngClass]="{'col-md-2':shipping_info.shipping.status !='SENT','col-md-3':shipping_info.shipping.status=='SENT'}">
							<label class="d-md-none fw-bold">Merma</label>
								<ng-container *ngIf="!sii.shipping_item.serial_number">
								<ng-container *ngIf="!hasBatches(sii)">
									<input *ngIf="shipping_info.shipping.status	!= 'DELIVERED'" type="number" [name]="'shippint_item_merma'+sii.shipping_item.item_id" min="0" [(ngModel)]="sii.shipping_item.shrinkage_qty" (change)="calculateReceivedItems()" class="form-control text-end" required>
								</ng-container>
								<ng-container *ngIf="hasBatches(sii) && shipping_info.shipping.status != 'DELIVERED'">
									<span class="text-muted">(ver lotes)</span>
								</ng-container>
								<ng-container *ngIf="shipping_info.shipping.status	== 'DELIVERED'">
									{{sii.shipping_item.shrinkage_qty| number }}
								</ng-container>
							</ng-container>
						</div>

						<div class="col-12 col-md-2 align-self-center text-center mt-3 mt-md-0" *ngIf="shipping_info.shipping.status == 'SENT'">
							<label class="d-md-none fw-bold mb-1">Almacén Destino</label>
							<div class="input-group" *ngIf="available_storages.length > 0">
								<select class="form-select form-control" [(ngModel)]="sii.storage_action" (change)="onStorageActionChange(sii, $event)" [name]="'storage_action_'+i">
									<option value="SIN_ASIGNAR">Sin Asignar</option>
									<option value="PERSONALIZADO">Personalizado (Varias cant.)</option>
									<option *ngFor="let st of available_storages" [value]="st.storage.id">{{st.storage.name}}</option>
								</select>
								<button *ngIf="sii.storage_action === 'PERSONALIZADO'" class="btn btn-outline-secondary" type="button" (click)="openStorageModal(sii)" title="Configurar cantidades asignadas">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/></svg>
								</button>
							</div>
							<span *ngIf="available_storages.length === 0" class="text-muted" style="font-size:0.9em">Sin almacenes</span>
						</div>

					</div>

					<!-- Batch details expandable section -->
					<div *ngIf="hasBatches(sii) && $any(sii).show_batches" class="row mb-2">
						<div class="col-12">
							<div class="card card-body bg-light py-2 px-3">
								<div class="small fw-bold mb-2">Detalle de lotes</div>
								<table class="table table-sm table-borderless mb-0">
									<thead>
										<tr class="text-muted">
											<th *ngIf="sii.item?.batch_option === 'BATCH_ONLY' || sii.item?.batch_option === 'BATCH_AND_EXPIRATION'">Lote</th>
											<th *ngIf="sii.item?.batch_option === 'EXPIRATION_ONLY' || sii.item?.batch_option === 'BATCH_AND_EXPIRATION'">Caducidad</th>
											<th class="text-end">Enviado</th>
											<th class="text-end">Recibido</th>
											<th class="text-end">Merma</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let batch of sii.shipping_item_batches; let bi = index">
											<td *ngIf="sii.item?.batch_option === 'BATCH_ONLY' || sii.item?.batch_option === 'BATCH_AND_EXPIRATION'">
												<ng-container *ngIf="shipping_info.shipping.status == 'SENT'">
													<input type="text" class="form-control form-control-sm"
														[name]="'batch_val_'+sii.shipping_item.id+'_'+bi"
														[(ngModel)]="batch.batch" required>
												</ng-container>
												<ng-container *ngIf="shipping_info.shipping.status == 'DELIVERED'">
													{{batch.batch}}
												</ng-container>
											</td>
											<td *ngIf="sii.item?.batch_option === 'EXPIRATION_ONLY' || sii.item?.batch_option === 'BATCH_AND_EXPIRATION'">
												<ng-container *ngIf="shipping_info.shipping.status == 'SENT'">
													<input type="date" class="form-control form-control-sm"
														[name]="'expiration_date_'+sii.shipping_item.id+'_'+bi"
														[(ngModel)]="batch.expiration_date" required>
												</ng-container>
												<ng-container *ngIf="shipping_info.shipping.status == 'DELIVERED'">
													{{batch.expiration_date}}
												</ng-container>
											</td>
											<td class="text-end">{{batch.qty | number}}</td>
											<td class="text-end">
												<ng-container *ngIf="shipping_info.shipping.status == 'SENT'">
													<input type="number" class="form-control form-control-sm text-end" style="width:80px;display:inline-block"
														[name]="'batch_received_'+sii.shipping_item.id+'_'+bi"
														min="0" [max]="batch.qty"
														[(ngModel)]="batch.received_qty"
														(ngModelChange)="onBatchQtyChange(sii)">
												</ng-container>
												<ng-container *ngIf="shipping_info.shipping.status == 'DELIVERED'">
													{{batch.received_qty | number}}
												</ng-container>
											</td>
											<td class="text-end">
												<ng-container *ngIf="shipping_info.shipping.status == 'SENT'">
													<input type="number" class="form-control form-control-sm text-end" style="width:80px;display:inline-block"
														[name]="'batch_shrinkage_'+sii.shipping_item.id+'_'+bi"
														min="0"
														[(ngModel)]="batch.shrinkage_qty"
														(ngModelChange)="onBatchQtyChange(sii)">
												</ng-container>
												<ng-container *ngIf="shipping_info.shipping.status == 'DELIVERED'">
													{{batch.shrinkage_qty | number}}
												</ng-container>
											</td>
										</tr>
									</tbody>
									<tfoot>
										<tr class="fw-bold border-top">
											<td [attr.colspan]="sii.item?.batch_option === 'BATCH_AND_EXPIRATION' ? 1 : 0"></td>
											<td class="text-end">Total:</td>
											<td class="text-end">{{getBatchTotal(sii, 'qty') | number}}</td>
											<td class="text-end" [ngClass]="{'text-success': getBatchTotal(sii, 'received_qty') === sii.shipping_item.received_qty, 'text-danger': getBatchTotal(sii, 'received_qty') !== sii.shipping_item.received_qty}">
												{{getBatchTotal(sii, 'received_qty') | number}}
											</td>
											<td class="text-end" [ngClass]="{'text-success': getBatchTotal(sii, 'shrinkage_qty') === (sii.shipping_item.shrinkage_qty || 0), 'text-danger': getBatchTotal(sii, 'shrinkage_qty') !== (sii.shipping_item.shrinkage_qty || 0)}">
												{{getBatchTotal(sii, 'shrinkage_qty') | number}}
											</td>
										</tr>
									</tfoot>
								</table>
							</div>
						</div>
					</div>
				</ng-container>
				<div class="row py-3"  *ngIf="shipping_info?.shipping?.status == 'SENT'">
					<div class="col-12 text-end">
						<button form="save-shipping" type="submit"	[disabled]="is_loading" class="btn btn-primary">
							<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1.3em" height="1.3em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 20 20"><path d="M15.173 2H4c-1.101 0-2 .9-2 2v12c0 1.1.899 2 2 2h12c1.101 0 2-.9 2-2V5.127L15.173 2zM14 8c0 .549-.45 1-1 1H7c-.55 0-1-.451-1-1V3h8v5zm-1-4h-2v4h2V4z" fill="currentColor"/></svg>
							Guardar
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<app-modal [(show)]="show_storage_modal" [biggest_posible]="true">
	<div class="p-3" *ngIf="custom_storage_item">
		<h4>Asignación Personalizada - {{custom_storage_item.item.name}}</h4>
		<p class="text-muted">Desglose la cantidad recibida en múltiples almacenes.</p>

		<div class="table-responsive">
			<table class="table table-sm">
				<thead>
					<tr>
						<th>Almacén</th>
						<th>Cantidad Asignada</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let row of custom_storage_rows; let i = index">
						<td>
							<select class="form-select form-control form-control-sm" [(ngModel)]="row.storage_id">
								<option [ngValue]="null">Seleccionar</option>
								<option *ngFor="let st of available_storages" [value]="st.storage.id">{{st.storage.name}}</option>
							</select>
						</td>
						<td>
							<input type="number" class="form-control form-control-sm text-end" [(ngModel)]="row.qty" min="0" [step]="custom_storage_item.item?.partial_sale == 'NO' ? '1' : 'any'">
						</td>
						<td class="text-end">
							<button type="button" class="btn btn-sm btn-danger" (click)="removeStorageRow(i)" [disabled]="custom_storage_rows.length <= 1">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/><path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/></svg>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<button type="button" class="btn btn-sm btn-secondary mb-3" (click)="addStorageRow()">+ Agregar Almacén</button>

		<div class="row">
			<div class="col-6">
				<button type="button" class="btn btn-secondary w-100" (click)="cancelCustomStorage()">Cancelar</button>
			</div>
			<div class="col-6">
				<button type="button" class="btn btn-primary w-100" (click)="confirmCustomStorage()">Confirmar</button>
			</div>
		</div>
	</div>
</app-modal>
